import React, { useContext, useState, useEffect, FC } from 'react';
import { useTranslation } from 'react-i18next';

// Custom Components
import model from '@/models/tenant';
import ModelTable from '@/ui/Table/ModelTable';
import LoaderContext, { LoaderContextType } from '@/context/LoaderContext/LoaderContext';

import DataController, { IDataController } from '@/lib/DataController';

// Types
import { DCRecord } from '@/@types/lib/dataController';
import { IViewCollection } from '@/@types/models/model';

type ILoginLogsTableProps = {
  onSelectRecord: (tenantId: number) => void,
}

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them
const LoginLogsTable: FC<ILoginLogsTableProps> = (props) => {
  const loaderContext = useContext(LoaderContext) as LoaderContextType;

  const { onSelectRecord } = props;

  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new DataController(model);

  const expandedlistViews: IViewCollection = {
    default: {
      fields: ['id', 'name_ttoken', 'tag', 'host', 'tenant_state_id', 'last_login_user_id', 'last_login_user_name', 'last_login_on'],
    }
  }
  dc.listViews = expandedlistViews;


  useEffect(() => {
    refreshRecords();
  }, []);

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData()
      .then((resp) => {
        if (resp.success) {
          if (Array.isArray(resp.data)) {
            setRecords(resp.data);
          } else {
            setRecords([]);
          }
        }
      })
      .finally(() => {
        loaderContext.toggleLoading(false);
      });
  };

  const selectRow = (evt: React.SyntheticEvent, sel: { [key: string]: DCRecord }) => {
    const selId: number = parseInt(Object.keys(sel)[0], 10);
    const tenantId = records[selId].id as number

    onSelectRecord(tenantId);
  };

  return (
    <ModelTable
      title={t('admin:titles.login_logs')}
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter
      allowExport
      allowColumnPicker
      onRowAction={() => { }}
      allowRowAction={() => true}
      unselectRow={false}
      onRowClick={selectRow}
    />
  );
}

export default LoginLogsTable;
